import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { Type } from '../../../services/FilesAndDirectoriesService'
import FilesAndDirectoriesService from '../../../services/FilesAndDirectoriesService'

type RenameItemPayload = {
  organization: string
  path: string
  newName: string
  type: Type
}

export const useRenameItem = (directoryPath?: string) => {
  const { org, project } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, RenameItemPayload>({
    mutationKey: ['rename-project-item'],
    mutationFn: ({ organization, path, newName, type }) =>
      FilesAndDirectoriesService.rename(organization, path, newName, type),
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
